import React from 'react';

import { defineMessages, useIntl } from 'react-intl';

import MenuSectionDualHeading from 'components/menu-section-dual-heading';

export const ListViewHeading: React.FC = () => {
  const { formatMessage } = useIntl();

  return (
    <MenuSectionDualHeading
      heading={formatMessage(messages.timHortons)}
      subheading={formatMessage(messages.locations)}
    />
  );
};
const messages = defineMessages({
  locations: {
    id: 'locations',
    defaultMessage: 'Locations',
    description: 'No description',
  },

  timHortons: {
    id: 'timHortons',
    defaultMessage: 'Tim Hortons',
    description: 'No description',
  },
});
